import { useQuery } from '@tanstack/react-query';

import { baseAPI } from './base-api';
import { KEYS } from './query-keys';

export interface GHLUser {
  id: string;
  name: string;
  email: string;
  role: string;
  // Add other fields as needed
}

export const getGHLLocationUsersAPI = async (): Promise<Array<GHLUser>> => {
  const response = await baseAPI.get<Array<GHLUser>>('/users/crm-unlinked');
  return response.data;
};

export const useGetGHLUsers = () =>
  useQuery({
    queryKey: [KEYS.UNLINKED_CRM_USERS],
    queryFn: getGHLLocationUsersAPI,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

